import React from "react";
import { Drawer, Toolbar, Divider, List, ListItem, ListItemButton, ListItemIcon, ListItemText, Box, useTheme } from "@mui/material";
import useResponsive from "../../utils/useResponsive";
import { useNavigate, useLocation } from "react-router-dom";
import AssessmentIcon from '@mui/icons-material/Assessment';
import GroupsIcon from '@mui/icons-material/Groups';
import AppRegistrationIcon from '@mui/icons-material/AppRegistration';
import SendIcon from '@mui/icons-material/Send';
import { isStudent, useAuth } from "../../contexts/AuthContext";
import DoubleArrowRoundedIcon from '@mui/icons-material/DoubleArrowRounded';
import CommentIcon from '@mui/icons-material/Comment';
import PieChartIcon from '@mui/icons-material/PieChart';

const LeftNavBar = ({ open, closeNav }) => {
    const drawerWidth = 220;
    const isDesktop = useResponsive('up', 'lg');
    const navigate = useNavigate();
    const location = useLocation();
    const theme = useTheme();
    const path = location.pathname.split("/")[2] || ""
    /*
    <ListItem disablePadding>
                            <ListItemButton 
                                onClick={() => { navigate('/app/group', { replace: false }) }}
                                sx={{
                                    borderRadius: 2,
                                    mx: 1,
                                    mb: 0.5,
                                    backgroundColor: path === "group" ? 'primary.main' : 'transparent',
                                    color: path === "group" ? 'white' : 'inherit',
                                    '&:hover': {
                                        backgroundColor: path === "group" ? 'primary.dark' : 'action.hover',
                                    },
                                    transition: 'all 0.2s ease-in-out',
                                }}
                            >
                                <ListItemIcon sx={{color : path === "group"? "white" : 'inherit', minWidth: 40}}>
                                    <GroupsIcon />
                                </ListItemIcon>
                                <ListItemText primary="Groups" sx={{color : path === "group"? "white" : 'inherit'}} />
                                {(path === "group") && <DoubleArrowRoundedIcon sx={{ color: "white" }} />}
                            </ListItemButton>
                        </ListItem>
    */
    const renderContent = (
        <Box sx={{ overflow: 'auto', scrollbarWidth: 'thin' }}>
            <List>
                <ListItem disablePadding>
                    <ListItemButton 
                        onClick={() => { navigate('/app/overview', { replace: false })}} 
                        sx={{
                            borderRadius: 2,
                            mx: 1,
                            mb: 0.5,
                            backgroundColor: path === "overview" ? 'primary.main' : 'transparent',
                            color: path === "overview" ? 'white' : 'inherit',
                            '&:hover': {
                                backgroundColor: path === "overview" ? 'primary.dark' : 'action.hover',
                            },
                            transition: 'all 0.2s ease-in-out',
                        }}
                    >
                        <ListItemIcon sx={{color : path === "overview"? "white" : 'inherit', minWidth: 40}}>
                            <PieChartIcon />
                        </ListItemIcon>
                        <ListItemText primary="Overview" sx={{color : path === "overview"? "white" : 'inherit'}}/>
                        {(path === "overview") && <DoubleArrowRoundedIcon sx={{ color: "white" }} />}
                    </ListItemButton>
                </ListItem>
                {isStudent() ? (<></>) : (
                    <>
                        <ListItem disablePadding>
                            <ListItemButton 
                                onClick={() => { navigate('/app/invite', { replace: false }) }}
                                sx={{
                                    borderRadius: 2,
                                    mx: 1,
                                    mb: 0.5,
                                    backgroundColor: path === "invite" ? 'primary.main' : 'transparent',
                                    color: path === "invite" ? 'white' : 'inherit',
                                    '&:hover': {
                                        backgroundColor: path === "invite" ? 'primary.dark' : 'action.hover',
                                    },
                                    transition: 'all 0.2s ease-in-out',
                                }}
                            >
                                <ListItemIcon sx={{color : path === "invite"? "white" : 'inherit', minWidth: 40}}>
                                    <SendIcon />
                                </ListItemIcon>
                                <ListItemText primary="Invite" sx={{color : path === "invite"? "white" : 'inherit'}} />
                                {(path === "invite") && <DoubleArrowRoundedIcon sx={{ color: "white" }} />}
                            </ListItemButton>
                        </ListItem>
                        <ListItem disablePadding>
                            <ListItemButton 
                                onClick={() => { navigate('/app/enroll', { replace: false }) }}
                                sx={{
                                    borderRadius: 2,
                                    mx: 1,
                                    mb: 0.5,
                                    backgroundColor: path === "enroll" ? 'primary.main' : 'transparent',
                                    color: path === "enroll" ? 'white' : 'inherit',
                                    '&:hover': {
                                        backgroundColor: path === "enroll" ? 'primary.dark' : 'action.hover',
                                    },
                                    transition: 'all 0.2s ease-in-out',
                                }}
                            >
                                <ListItemIcon sx={{color : path === "enroll"? "white" : 'inherit', minWidth: 40}}>
                                    <AppRegistrationIcon />
                                </ListItemIcon>
                                <ListItemText primary="Enrollment" sx={{color : path === "enroll"? "white" : 'inherit'}}/>
                                {(path === "enroll") && <DoubleArrowRoundedIcon sx={{ color: "white" }} />}
                            </ListItemButton>
                        </ListItem>
                        
                    </>
                )}
                <ListItem disablePadding>
                    <ListItemButton 
                        onClick={() => { navigate('/app/practice', { replace: false }) }}
                        sx={{
                            borderRadius: 2,
                            mx: 1,
                            mb: 0.5,
                            backgroundColor: path === "practice" ? 'primary.main' : 'transparent',
                            color: path === "practice" ? 'white' : 'inherit',
                            '&:hover': {
                                backgroundColor: path === "practice" ? 'primary.dark' : 'action.hover',
                            },
                            transition: 'all 0.2s ease-in-out',
                        }}
                    >
                        <ListItemIcon sx={{color : path === "practice"? "white" : 'inherit', minWidth: 40}}>
                            <AssessmentIcon />
                        </ListItemIcon>
                        <ListItemText primary="Practice" sx={{color : path === "practice"? "white" : 'inherit'}} />
                        {(path === "practice") && <DoubleArrowRoundedIcon sx={{ color: "white" }} />}
                    </ListItemButton>
                </ListItem>
                <ListItem disablePadding sx={{display: "none"}}>
                    <ListItemButton onClick={() => { navigate('/app/competition', { replace: false }) }}>
                        <ListItemIcon sx={{color : path === "competition"? "primary.main" : 'inherit'}}>
                            <AssessmentIcon />
                        </ListItemIcon>
                        <ListItemText primary="Competitions" sx={{color : path === "competition"? "primary.main" : 'inherit'}} />
                        {(path === "competition") && <DoubleArrowRoundedIcon sx={{ color: "primary.main" }} />}
                    </ListItemButton>
                </ListItem>
                <ListItem disablePadding>
                    <ListItemButton 
                        onClick={() => { navigate('/app/feedback', { replace: false }) }}
                        sx={{
                            borderRadius: 2,
                            mx: 1,
                            mb: 0.5,
                            backgroundColor: path === "feedback" ? 'primary.main' : 'transparent',
                            color: path === "feedback" ? 'white' : 'inherit',
                            '&:hover': {
                                backgroundColor: path === "feedback" ? 'primary.dark' : 'action.hover',
                            },
                            transition: 'all 0.2s ease-in-out',
                        }}
                    >
                        <ListItemIcon sx={{color : path === "feedback"? "white" : 'inherit', minWidth: 40}}>
                            <CommentIcon />
                        </ListItemIcon>
                        <ListItemText primary="Feedback" sx={{color : path === "feedback"? "white" : 'inherit'}} />
                        {(path === "feedback") && <DoubleArrowRoundedIcon sx={{ color: "white" }} />}
                    </ListItemButton>
                </ListItem>
            </List>
            <Divider />
        </Box>
    )

    return (
        <Box>
            {isDesktop ? (
                <Drawer
                    sx={{
                        width: drawerWidth,
                        flexShrink: 0,
                        '& .MuiDrawer-paper': {
                            width: drawerWidth,
                            boxSizing: 'border-box',
                            borderRight: 'none',
                            boxShadow: (theme) => theme.palette.mode === 'dark' ? '2px 0 8px rgba(0,0,0,0.5)' : '2px 0 8px rgba(0,0,0,0.08)',
                            backgroundColor: 'background.paper',
                        },
                    }}
                    variant="permanent"
                    anchor="left"
                >
                    <Toolbar></Toolbar>
                    {renderContent}
                </Drawer>
            ) : (
                <Drawer
                    open={open}
                    onClose={closeNav}
                    sx={{
                        width: drawerWidth,
                        flexShrink: 0,
                        '& .MuiDrawer-paper': {
                            width: drawerWidth,
                            boxSizing: 'border-box',
                            borderRight: 'none',
                            boxShadow: (theme) => theme.palette.mode === 'dark' ? '2px 0 16px rgba(0,0,0,0.5)' : '2px 0 16px rgba(0,0,0,0.12)',
                            backgroundColor: 'background.paper',
                        },
                    }}
                    anchor="left"
                    onClick={closeNav}
                >
                    <Toolbar></Toolbar>
                    {renderContent}
                </Drawer>)
            }
        </Box>
    );
}

export default LeftNavBar;